module.exports = __webpack_public_path__ + "static/media/defaultavatar.02624da3.png";